<template>
    <div v-if="show" class="mask">
        <div  class="form-modal copy-modal flex flex-col flex-space-between book">
        <div class="flex flex-space-between flex-center-cz title border-box">
            <div class="margin-left-l font-s">确认</div>
            <img src="@/assets/images/guanbi.png" class="logo-18 margin-right-m pointer" @click="close"/>
        </div>
        
        <div class="flex flex-col body padding-top-l border-box " style="height: calc(100% - 100px)" >
            <div class="flex flex-center-sp font-m margin-top-l" >该文档不是您所创建，将以此为基础创建您的版本？</div>
            <div class="margin-top-xl flex flex-center-sp">
                <RadioBoxList :data="option" v-model="value"  ></RadioBoxList>
            </div>
        </div>
        <div class="flex flex-center-sp flex-center-cz toolbar border-box">
            <div class="margin-right-s ui-no-button flex flex-center-cz flex-center-sp" @click="close">取消</div>
            <div class="margin-left-s ui-yes-button flex flex-center-cz flex-center-sp" @click="confirm">确定</div>          
        </div>

        </div>
    </div>

</template>

<script>
    import RichText from '@/components/richText/RichText' 
    import MySwitch from '@/components/switch/Switch'
    import RadioBoxList from '@/components/radioBoxList/RadioBoxList'
    import {objToStr} from '@/utils/sysUtils'
    

    export default {
        name:'CopyConfirmModal',
        created() {
        },
        components:{RichText,MySwitch,RadioBoxList},
        props:{
            title:{},
            open:{}
        },
        watch:{
            open: {
                handler(newValue) {
                    this.show = newValue;
                },
                immediate: true,
                deep: true 
            },

        },
        data() {
            return {
                show: null,
                option:[
                    {text:"全部照搬",value:"all"},
                    {text:"只要关于我的",value:"me"}
                ],
                value: "1"

            }
        },
        methods:{
            confirm() {
                this.$emit("confirm", this.value);
            },           
            close() {
                this.$emit("close")
            },

        }
   }
</script>

<style scoped>

    .form-modal {
        top: 50px;
    }
    .copy-modal {
        width: 500px;
        height: 300px;
    }
    .edit-area {
       width: 300px;
    }

    .body .row {
        line-height: 40px;
    }
</style>


// WEBPACK FOOTER //
// src/views/modal/CopyConfirmModal.vue